import { render, staticRenderFns } from "./video-list.vue?vue&type=template&id=26732a8c"
import script from "./video-list.vue?vue&type=script&lang=js"
export * from "./video-list.vue?vue&type=script&lang=js"
import style0 from "./video-list.vue?vue&type=style&index=0&id=26732a8c&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports